<template>
    <div id="visitor-detail">
        <a-spin :spinning="loading">
            <div class="detail-head">
                <div class="head-color">
                    <div class="head-info">
                        <div class="info-item" @click="copyToClipboard(visitor._id)">
                            <span class="material-icons">badge</span>
                            <span class="info-text">{{ visitor._id }}</span>
                            <span class="copy-icon material-icons">content_copy</span>
                        </div>
                        <div class="info-separator">
                            <span class="material-icons">fiber_manual_record</span>
                        </div>
                        <div class="info-item" @click="copyToClipboard(maskVisitorField('email', visitor.email) || $t('visitor.notAvailable'))">
                            <span class="material-icons">email</span>
                            <span class="info-text">{{ maskVisitorField('email', visitor.email) || $t("visitor.notAvailable") }}</span>
                            <span class="copy-icon material-icons">content_copy</span>
                        </div>
                        <div class="info-separator">
                            <span class="material-icons">fiber_manual_record</span>
                        </div>
                        <div class="info-item" @click="copyToClipboard(getChannelNameOrPlatform())">
                            <span style="display: flex; align-items: center; margin-right: 5px; margin-bottom: -13px">
                                <PlatformIconViewer v-if="visitor" :platform="visitor.platform" style="width: 16px; height: 16px" />
                            </span>
                            <span class="info-text">{{ getChannelNameOrPlatform() }}</span>
                            <span class="copy-icon material-icons">content_copy</span>
                        </div>
                    </div>
                </div>
                <div class="header-wrapper">
                    <div class="avatar-section">
                        <span class="user-segment-avatar text-center">
                            <div
                                class="banned-frame"
                                v-if="isBannedAnyPlatform()"
                                @click="ban"
                                v-tippy="{ followCursor: true, placement: 'top-center' }"
                                :content="$t('visitor.blockManagement')"
                            >
                                <div class="material-icons">block</div>
                                <div class="banned-text">{{ $t("message.blocked") }}</div>
                            </div>
                            <ContactAvatar
                                :contact="visitor"
                                :badge="true"
                                style="--background-color: transparent; width: 100px; height: 90px"
                            />
                            <!--                            <md-highlight-text md-term="term" class="text-center">-->
                            <!--                                {{ !!visitor.fullname ? visitor.fullname.substr(0, 1).toUpperCase() : "V" }}-->
                            <!--                            </md-highlight-text>-->
                        </span>
                    </div>

                    <div class="user-info-section">
                        <div class="user-name-row">
                            <h1 class="user-name">{{ visitor.fullname ? maskVisitorField('fullname', visitor.fullname) : $t("visitor.defaultName") }}</h1>
                            <div class="vip-switch-container">
                                <a-switch
                                    :checked="visitor.vipCustomer"
                                    @change="vipCustomerChange"
                                    checked-children="VIP"
                                    un-checked-children="VIP"
                                    v-tippy="{ followCursor: true, placement: 'top-center' }"
                                    :content="$t('visitor.vipCustomer')"
                                />
                            </div>
                        </div>

                        <div class="user-email">
                            <span>
                                {{ visitor.email ? maskVisitorField('email', visitor.email) : $t("visitor.noEmail") }}
                            </span>
                            <span v-if="!!visitor.emailVerified" class="material-icons mail-check">verified_user</span>
                            <span v-else class="mail-close">({{ $t("message.notVerified") }})</span>
                        </div>

                        <div class="user-segments-tags-row">
                            <div class="segment-chips">
                                <div
                                    class="segment-chip"
                                    v-for="(segment, index) in selectedSegmentsList.slice(0, 1)"
                                    :key="index"
                                >
                                    {{ segment.name }}
                                </div>
                                <div
                                    class="segment-chip more-chip"
                                    v-if="selectedSegmentsList.length > 1"
                                    @click="segmentModalVisible = true"
                                >
                                    +{{ selectedSegmentsList.length - 1 }}
                                </div>
                                <div class="segment-chip add-segment-btn" @click="segmentModalVisible = true">
                                    <span class="material-icons">add</span>
                                    <span>{{ $t("visitor.addSegment") }}</span>
                                </div>

                                <div
                                    class="segment-chip tag-chip"
                                    v-for="(tag, index) in selectedTagsList.slice(0, 1)"
                                    :key="'tag-' + index"
                                >
                                    <span class="material-icons tag-icon">local_offer</span>
                                    {{ tag.name }}
                                </div>
                                <div
                                    class="segment-chip more-chip"
                                    v-if="selectedTagsList.length > 1"
                                    @click="tagModalVisible = true"
                                >
                                    +{{ selectedTagsList.length - 1 }}
                                </div>
                                <div class="segment-chip add-segment-btn" @click="tagModalVisible = true">
                                    <span class="material-icons">add</span>
                                    <span>{{ $t("visitor.addTag") }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="quick-action-buttons">
                            <div class="action-icons">
                                <button
                                    class="icon-btn"
                                    v-if="isWABusiness() || isWhatsappV1() || isWhatsappV2() || isWhatsappV3()"
                                    @click="startWhatsappChat()"
                                    v-tippy="{ followCursor: true, placement: 'top-center' }"
                                    :content="$t('visitor.startChat')"
                                >
                                    <span class="material-icons">chat</span>
                                </button>
                                <button
                                    class="icon-btn"
                                    @click="openNewEvent"
                                    v-tippy="{ followCursor: true, placement: 'top-center' }"
                                    :content="$t('visitor.createEvent')"
                                >
                                    <span class="material-icons">event</span>
                                </button>
                                <button
                                    class="icon-btn"
                                    @click="createTask()"
                                    v-tippy="{ followCursor: true, placement: 'top-center' }"
                                    :content="$t('visitor.createTask')"
                                >
                                    <span class="material-icons">assignment</span>
                                </button>
                                <ContactProfileAutomationButton
                                    :contactId="visitorId"
                                    v-if="visitorId"
                                    :showText="false"
                                    subMenuMode="inline"
                                />
                                <AiVoiceAgentCallStarter
                                    :contact="visitor"
                                    :default-to-number="visitor.phone || visitor.whatsappNumber"
                                    :hide-button="false"
                                />
                                <button
                                    class="icon-btn webphone-call-btn"
                                    @click="startWebphoneCall()"
                                    v-tippy="{ followCursor: true, placement: 'top-center' }"
                                    :content="$t('visitor.webphoneCall')"
                                    v-if="visitor.phone || visitor.whatsappNumber"
                                >
                                    <span class="material-icons">phone</span>
                                </button>
                                <button
                                    class="icon-btn capi-event-btn"
                                    @click="openCapiEventModal()"
                                    v-tippy="{ followCursor: true, placement: 'top-center' }"
                                    :content="$t('visitor.capiEventSend')"
                                    v-if="isMetaPlatform()"
                                >
                                    <span class="material-icons">ads_click</span>
                                </button>
                                <button
                                    class="icon-btn"
                                    @click="ban()"
                                    v-tippy="{ followCursor: true, placement: 'top-center' }"
                                    :content="$t('visitor.blockManagement')"
                                >
                                    <span class="material-icons">block</span>
                                </button>
                                <div class="more-menu" v-if="visitorDetailPermission">
                                    <a-dropdown>
                                        <button class="icon-btn">
                                            <span class="material-icons">more_horiz</span>
                                        </button>
                                        <a-menu slot="overlay" class="visitor-detail-more-menu-dropdown">
                                            <a-menu-item
                                                v-if="checkPermission(PERMISSION_TYPES['visitor.delete'].tr.name)"
                                                @click="deleteUserVisible = true"
                                            >
                                                <div style="display: flex; justify-content: start">
                                                    <span class="material-icons mr-2" style="color: #dc2626"
                                                        >delete</span
                                                    >
                                                    {{ $t("visitor.deleteUser") }}
                                                </div>
                                            </a-menu-item>
                                            <!--                                            <a-menu-item-->
                                            <!--                                                v-if="-->
                                            <!--                                                    !visitorBanned &&-->
                                            <!--                                                    checkPermission(PERMISSION_TYPES['visitor.block'].tr.name)-->
                                            <!--                                                "-->
                                            <!--                                                @click="ban()"-->
                                            <!--                                            >-->
                                            <!--                                                <div style="display: flex; justify-content: start">-->
                                            <!--                                                    <span class="material-icons mr-2" style="color: #f97316"-->
                                            <!--                                                        >block</span-->
                                            <!--                                                    >-->
                                            <!--                                                    {{ $t("message.blockManagement") }}-->
                                            <!--                                                </div>-->
                                            <!--                                            </a-menu-item>-->
                                        </a-menu>
                                    </a-dropdown>
                                </div>
                            </div>
                            <div class="action-right" ref="actionRight" v-if="visitorTask && visitorTask.length > 0">
                                <div class="workflow-select-container">
                                    <div class="workflow-name">
                                        <span>
                                            {{ visitorTask[selectedTaskIndex].workflowId.title }}
                                        </span>
                                    </div>
                                    <div class="select">
                                        <span class="md-icon" style="color: #818793; font-size: 20px !important">assignment</span>
                                        <a-select
                                            v-if="visitorTask && visitorTask.length > 0"
                                            v-model="selectedTaskIndex"
                                            style="width: 200px"
                                            :placeholder="$t('visitor.selectTask')"
                                        >
                                            <a-select-option
                                                v-for="(task, index) in visitorTask"
                                                :key="index"
                                                :value="index"
                                            >
                                                {{ task.title }}
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div class="ticket-status-switcher-container">
                                    <TicketStatusSwitcher
                                        v-if="visitorTask && visitorTask.length > 0"
                                        :status-list="visitorTask[selectedTaskIndex].statusList"
                                        :current-status="visitorTask[selectedTaskIndex].currentStatus"
                                        :default-color="'#91a2b6'"
                                        :active-color="'#634eec'"
                                        :hover-color="'#634eec'"
                                        :isVisitor="true"
                                        @update-status-visitor="handleStageChange"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="header-controls">
                        <div class="header-control-item preferred-agents-section">
                            <div class="control-label">
                                <span class="material-icons">support_agent</span>
                                <span>{{ $t("userInfoWidget.preferredAgents") }}</span>
                            </div>
                            <div class="control-content">
                                <PreferredAgents
                                    v-if="visitor"
                                    :visitorId="cloneVisitorId"
                                    v-model="visitor.preferredAgents"
                                />
                            </div>
                        </div>

                        <div class="header-control-item preferred-department-section">
                            <div class="control-label">
                                <span class="material-icons">group</span>
                                <span>{{ $t("message.preferredDepartment") }}</span>
                            </div>
                            <div class="control-content">
                                <PreferredDepartment
                                    :visitorId="cloneVisitorId"
                                    v-model="visitor.preferredDepartment"
                                />
                            </div>
                        </div>

                        <div class="header-control-item ownership-section">
                            <div class="control-label">
                                <span class="material-icons">person_outline</span>
                                <span>{{ $t("message.customerOwnership") }}</span>
                            </div>
                            <a-select :value="getOwnerVal()" @change="ownerChange" class="owner-select">
                                <a-select-option value="">{{ $t("message.ownerless") }}</a-select-option>
                                <a-select-option v-for="user in users" :key="user._id" :value="user._id">
                                    {{ user.name }}
                                </a-select-option>
                            </a-select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="page-tabs">
                <div
                    class="tab-item"
                    :class="{ active: tabKey === 'visitor-details' }"
                    @click="changeTabKey('visitor-details')"
                >
                    <span class="material-icons">person</span>
                    {{ $t("message.profile") }}
                </div>
                <div
                    class="tab-item"
                    :class="{ active: tabKey === 'visitor-notes' }"
                    @click="changeTabKey('visitor-notes')"
                >
                    <span class="material-icons">note</span>
                    {{ $t("message.notes") }}
                </div>
                <div
                    class="tab-item"
                    :class="{ active: tabKey === 'visitor-activities' }"
                    @click="changeTabKey('visitor-activities')"
                >
                    <span class="material-icons">history</span>
                    {{ $t("wp.actions") }}
                </div>
                <div
                    class="tab-item"
                    :class="{ active: tabKey === 'visitor-chats' }"
                    @click="changeTabKey('visitor-chats')"
                >
                    <span class="material-icons">chat</span>
                    {{ $t("message.conversationHistory") }}
                </div>
                <div
                    class="tab-item"
                    :class="{ active: tabKey === 'visitor-mails' }"
                    @click="changeTabKey('visitor-mails')"
                >
                    <span class="material-icons">email</span>
                    {{ $t("message.mails") }}
                </div>
                <div
                    class="tab-item"
                    :class="{ active: tabKey === 'visitor-tasks' }"
                    @click="changeTabKey('visitor-tasks')"
                >
                    <span class="material-icons">check_circle</span>
                    {{ $t("message.assignedTasks") }}
                </div>
                <div
                    class="tab-item"
                    :class="{ active: tabKey === 'visitor-events' }"
                    @click="changeTabKey('visitor-events')"
                >
                    <span class="material-icons">event</span>
                    {{ $t("message.calendar") }}
                </div>
                <div
                    class="tab-item"
                    :class="{ active: tabKey === 'visitor-media' }"
                    @click="changeTabKey('visitor-media')"
                >
                    <span class="material-icons">image</span>
                    {{ $t("message.sumChat_MediaFile") }}
                </div>
                <div
                    class="tab-item"
                    :class="{ active: tabKey === 'visitor-related-list' }"
                    @click="changeTabKey('visitor-related-list')"
                >
                    <span class="material-icons">link</span>
                    {{ $t("visitor.relatedList") }}
                </div>
                <div
                    class="tab-item"
                    :class="{ active: tabKey === 'visitor-ad-referrals' }"
                    @click="changeTabKey('visitor-ad-referrals')"
                >
                    <span class="material-icons">ads_click</span>
                    {{ $t("visitor.adReferrals") }}
                </div>
                <div
                    class="tab-item"
                    :class="{ active: tabKey === 'visitor-calls' }"
                    @click="changeTabKey('visitor-calls')"
                >
                    <span class="material-icons">call</span>
                    {{ $t("visitor.calls") }}
                </div>
                <div
                    v-if="visitor.metaLeadInfo"
                    class="tab-item"
                    :class="{ active: tabKey === 'visitor-meta-lead' }"
                    @click="changeTabKey('visitor-meta-lead')"
                >
                    <span class="material-icons">leaderboard</span>
                    Meta Lead Form
                </div>
                <!-- WebTab Sekmeleri -->
                <div
                    v-for="webTab in visitorDetailWebTabs"
                    :key="'webtab-' + webTab._id"
                    class="tab-item webtab-tab"
                    :class="{ active: tabKey === 'webtab-' + webTab._id }"
                    @click="changeTabKey('webtab-' + webTab._id)"
                >
                    <span
                        class="material-icons"
                        :style="{ color: tabKey === 'webtab-' + webTab._id ? webTab.iconColor : '' }"
                    >
                        {{ webTab.icon }}
                    </span>
                    {{ webTab.name }}
                </div>
            </div>

            <div class="tab-content">
                <!-- Profil Detayları -->
                <div class="content-container" v-if="tabKey === 'visitor-details'">
                    <div class="profile-cards-grid">
                        <!-- Genel Bilgiler -->
                        <div class="profile-card flex-1">
                            <div class="visitor-card-header">
                                <span class="visitor-card-icon">
                                    <span class="material-icons">info</span>
                                </span>
                                <h4 class="visitor-card-title">{{ $t("visitor.generalInfo") }}</h4>
                            </div>
                            <div class="card-body">
                                <VisitorAttributes :visitor="visitor" :showOnlyGeneral="true" :isReadOnly="false" />
                            </div>
                        </div>

                        <!-- Profil Alanları -->
                        <div class="profile-card flex-1">
                            <div class="visitor-card-header">
                                <span class="visitor-card-icon">
                                    <span class="material-icons">person_outline</span>
                                </span>
                                <h4 class="visitor-card-title">{{ $t("visitor.profileFields") }}</h4>
                            </div>
                            <div class="card-body">
                                <VisitorAttributes
                                    :visitor="visitor"
                                    :showOnlyProfile="true"
                                    :isReadOnly="false"
                                    :metaReferralsBtn="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Diğer tabların içeriği -->
                <div class="content-container" v-if="tabKey === 'visitor-notes'">
                    <div class="profile-card full-width">
                        <div class="visitor-card-header">
                            <span class="visitor-card-icon">
                                <span class="material-icons">note</span>
                            </span>
                            <h4 class="visitor-card-title">{{ $t("message.notes") }}</h4>
                        </div>
                        <div class="card-body">
                            <VisitorNotes :notes="notes" :visitorId="cloneVisitorId" @note-added="fetchNotes" />
                        </div>
                    </div>
                </div>

                <div class="content-container" v-if="tabKey === 'visitor-activities'">
                    <div class="profile-card full-width">
                        <div class="visitor-card-header">
                            <span class="visitor-card-icon">
                                <span class="material-icons">history</span>
                            </span>
                            <h4 class="visitor-card-title">{{ $t("message.visitorActions") }}</h4>
                        </div>
                        <div class="card-body">
                            <VisitorActivities :visitor-id="cloneVisitorId" />
                        </div>
                    </div>
                </div>

                <div class="content-container" v-if="tabKey === 'visitor-chats'">
                    <div class="profile-card full-width">
                        <div class="visitor-card-header">
                            <span class="visitor-card-icon">
                                <span class="material-icons">chat</span>
                            </span>
                            <h4 class="visitor-card-title">{{ $t("visitor.userChats") }}</h4>
                            <div class="card-actions">
                                <button class="secondary-btn" @click="seeAll">
                                    <span class="material-icons">visibility</span>
                                    <span>{{ $t("visitor.seeAll") }}</span>
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <VisitorChatList :visitor-id="cloneVisitorId" @detailClose="closeModal" />
                        </div>
                    </div>
                </div>

                <div class="content-container" v-if="tabKey === 'visitor-mails'">
                    <div class="profile-card full-width">
                        <div class="visitor-card-header">
                            <span class="visitor-card-icon">
                                <span class="material-icons">email</span>
                            </span>
                            <h4 class="visitor-card-title">{{ $t("message.visitorMails") }}</h4>
                        </div>
                        <div class="card-body">
                            <VisitorMailList
                                :visitorMail="visitor.email"
                                :isGetChat="visibleMail"
                                :visitorId="cloneVisitorId"
                            />
                        </div>
                    </div>
                </div>

                <div class="content-container" v-if="tabKey === 'visitor-tasks'">
                    <div class="profile-card full-width">
                        <div class="visitor-card-header">
                            <span class="visitor-card-icon">
                                <span class="material-icons">check_circle</span>
                            </span>
                            <h4 class="visitor-card-title">{{ $t("message.assignedTasks") }}</h4>
                        </div>
                        <div class="card-body p-0">
                            <VisitorTaskListView :visitorId="cloneVisitorId" />
                        </div>
                    </div>
                    <a-tooltip placement="topLeft">
                        <template slot="title">
                            <span>{{ $t("task.createTask") }}</span>
                        </template>
                        <button class="add-attribute-button" @click="createTask()">
                            <span class="material-icons">add</span>
                        </button>
                    </a-tooltip>
                </div>

                <div class="content-container" v-if="tabKey === 'visitor-events'">
                    <div class="profile-card full-width">
                        <div class="visitor-card-header">
                            <span class="visitor-card-icon">
                                <span class="material-icons">event</span>
                            </span>
                            <h4 class="visitor-card-title">{{ $t("message.visitorEvents") }}</h4>
                        </div>
                        <div class="card-body p-0">
                            <VisitorEventList :visitorId="cloneVisitorId" :newEvent="newEvent" />
                        </div>
                    </div>
                    <a-tooltip placement="topLeft">
                        <template slot="title">
                            <span>{{ $t("visitor.createEvent") }}</span>
                        </template>
                        <button class="add-attribute-button" @click="openNewEvent">
                            <span class="material-icons">add</span>
                        </button>
                    </a-tooltip>
                </div>

                <div class="content-container" v-if="tabKey === 'visitor-media'">
                    <div class="profile-card full-width">
                        <div class="visitor-card-header">
                            <span class="visitor-card-icon">
                                <span class="material-icons">image</span>
                            </span>
                            <h4 class="visitor-card-title">{{ $t("message.sumChat_MediaFile") }}</h4>
                        </div>
                        <div class="card-body p-0">
                            <VisitorMediaAndDocuments :visitorId="cloneVisitorId" />
                        </div>
                    </div>
                </div>
                <div class="content-container" v-if="tabKey === 'visitor-ad-referrals'">
                    <div class="profile-card full-width">
                        <div class="visitor-card-header">
                            <span class="visitor-card-icon">
                                <span class="material-icons">ads_click</span>
                            </span>
                            <h4 class="visitor-card-title">{{ $t("visitor.adReferrals") }}</h4>
                        </div>
                        <div class="card-body p-0">
                            <MetaReferralList :contact="visitor" />
                        </div>
                    </div>
                </div>

                <div class="content-container" v-if="tabKey === 'visitor-related-list'">
                    <div class="profile-card full-width">
                        <div class="visitor-card-header">
                            <span class="visitor-card-icon">
                                <span class="material-icons">link</span>
                            </span>
                            <h4 class="visitor-card-title">{{ $t("visitor.relatedList") }}</h4>
                        </div>
                        <div class="card-body p-0">
                            <ContactRelatedList :contactId="cloneVisitorId" :contact="visitor" />
                        </div>
                    </div>
                </div>
                <div class="content-container" v-if="tabKey === 'visitor-calls'">
                    <div class="profile-card full-width">
                        <div class="visitor-card-header">
                            <span class="visitor-card-icon">
                                <span class="material-icons">call</span>
                            </span>
                            <h4 class="visitor-card-title">{{ $t("visitor.callHistory") }}</h4>
                        </div>
                        <div class="card-body p-0">
                            <VisitorCalls :visitorId="cloneVisitorId" :contact="visitor" :key="'calls-' + cloneVisitorId" />
                        </div>
                    </div>
                </div>
                <!-- Meta Lead Form -->
                <div class="content-container" v-if="tabKey === 'visitor-meta-lead' && visitor.metaLeadInfo">
                    <div class="profile-card full-width">
                        <div class="visitor-card-header">
                            <span class="visitor-card-icon">
                                <span class="material-icons">leaderboard</span>
                            </span>
                            <h4 class="visitor-card-title">Meta Lead Form</h4>
                        </div>
                        <div class="card-body meta-lead-info">
                            <div class="meta-lead-grid">
                                <div class="meta-lead-section">
                                    <h5 class="meta-lead-section-title">
                                        <span class="material-icons">campaign</span>
                                        Kampanya Bilgileri
                                    </h5>
                                    <div class="meta-lead-fields">
                                        <div class="meta-lead-field" v-if="visitor.metaLeadInfo.campaign_name">
                                            <span class="field-label">Kampanya</span>
                                            <span class="field-value">{{ visitor.metaLeadInfo.campaign_name }}</span>
                                        </div>
                                        <div class="meta-lead-field" v-if="visitor.metaLeadInfo.adset_name">
                                            <span class="field-label">Reklam Seti</span>
                                            <span class="field-value">{{ visitor.metaLeadInfo.adset_name }}</span>
                                        </div>
                                        <div class="meta-lead-field" v-if="visitor.metaLeadInfo.ad_name">
                                            <span class="field-label">Reklam</span>
                                            <span class="field-value">{{ visitor.metaLeadInfo.ad_name }}</span>
                                        </div>
                                        <div class="meta-lead-field" v-if="visitor.metaLeadInfo.form_name">
                                            <span class="field-label">Form</span>
                                            <span class="field-value">{{ visitor.metaLeadInfo.form_name }}</span>
                                        </div>
                                        <div class="meta-lead-field" v-if="visitor.metaLeadInfo.platform">
                                            <span class="field-label">Platform</span>
                                            <span class="field-value meta-lead-badge">{{ visitor.metaLeadInfo.platform === 'ig' ? 'Instagram' : visitor.metaLeadInfo.platform === 'fb' ? 'Facebook' : visitor.metaLeadInfo.platform }}</span>
                                        </div>
                                        <div class="meta-lead-field" v-if="visitor.metaLeadInfo.status">
                                            <span class="field-label">Durum</span>
                                            <span class="field-value meta-lead-badge" :class="'status-' + visitor.metaLeadInfo.status">{{ visitor.metaLeadInfo.status }}</span>
                                        </div>
                                        <div class="meta-lead-field" v-if="visitor.metaLeadInfo.created_time">
                                            <span class="field-label">Oluşturulma Tarihi</span>
                                            <span class="field-value">{{ $moment(visitor.metaLeadInfo.created_time).format('DD.MM.YYYY HH:mm') }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="meta-lead-section" v-if="visitor.metaLeadInfo.field_data && visitor.metaLeadInfo.field_data.length">
                                    <h5 class="meta-lead-section-title">
                                        <span class="material-icons">assignment</span>
                                        Form Yanıtları
                                    </h5>
                                    <div class="meta-lead-fields">
                                        <div class="meta-lead-field" v-for="(field, index) in visitor.metaLeadInfo.field_data" :key="index">
                                            <span class="field-label">{{ field.question ? field.question.label : field.name }}</span>
                                            <span class="field-value">{{ field.values ? field.values.join(', ') : '-' }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="meta-lead-section">
                                    <h5 class="meta-lead-section-title">
                                        <span class="material-icons">fingerprint</span>
                                        Teknik Bilgiler
                                    </h5>
                                    <div class="meta-lead-fields">
                                        <div class="meta-lead-field" v-if="visitor.metaLeadInfo.id">
                                            <span class="field-label">Lead ID</span>
                                            <span class="field-value field-mono">{{ visitor.metaLeadInfo.id }}</span>
                                        </div>
                                        <div class="meta-lead-field" v-if="visitor.metaLeadInfo.form_id">
                                            <span class="field-label">Form ID</span>
                                            <span class="field-value field-mono">{{ visitor.metaLeadInfo.form_id }}</span>
                                        </div>
                                        <div class="meta-lead-field" v-if="visitor.metaLeadInfo.ad_id">
                                            <span class="field-label">Ad ID</span>
                                            <span class="field-value field-mono">{{ visitor.metaLeadInfo.ad_id }}</span>
                                        </div>
                                        <div class="meta-lead-field" v-if="visitor.metaLeadInfo.adset_id">
                                            <span class="field-label">Adset ID</span>
                                            <span class="field-value field-mono">{{ visitor.metaLeadInfo.adset_id }}</span>
                                        </div>
                                        <div class="meta-lead-field" v-if="visitor.metaLeadInfo.campaign_id">
                                            <span class="field-label">Campaign ID</span>
                                            <span class="field-value field-mono">{{ visitor.metaLeadInfo.campaign_id }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- WebTab İçerikleri -->
                <div
                    class="content-container webtab-content"
                    v-if="tabKey.startsWith('webtab-')"
                >
                    <div class="profile-card full-width webtab-card">
                        <div class="visitor-card-header">
                            <span class="visitor-card-icon">
                                <span
                                    class="material-icons"
                                    :style="{ color: currentWebTab ? currentWebTab.iconColor : '' }"
                                >
                                    {{ currentWebTab ? currentWebTab.icon : 'tab' }}
                                </span>
                            </span>
                            <h4 class="visitor-card-title">{{ currentWebTab ? currentWebTab.name : $t("visitor.webTab") }}</h4>
                        </div>
                        <div class="card-body webtab-iframe-container">
                            <iframe
                                v-if="currentWebTabUrl"
                                :src="currentWebTabUrl"
                                class="webtab-iframe"
                                frameborder="0"
                                allow="camera; microphone; geolocation; fullscreen; autoplay; clipboard-read; clipboard-write"
                                sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals allow-downloads allow-top-navigation"
                            />
                            <div v-else class="webtab-error">
                                <span class="material-icons">error_outline</span>
                                <span>{{ $t("visitor.widgetUrlError") }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modaller -->
            <FormModal
                id="add-to-segment"
                :title="$t('visitor.addSegment')"
                v-model="segmentModalVisible"
                :footer="null"
                v-if="segmentModalVisible"
                @cancel="segmentModalVisible = false"
            >
                <template #body>
                    <div class="add-segment-search">
                        <input
                            :placeholder="$t('visitor.filterName')"
                            style="border: none"
                            v-model="segmentSearch"
                            @input="segmentSearchChange"
                        />
                        <span class="material-icons mx-2 add-segment-search-icon"> search </span>
                    </div>
                    <VisitorAddSegment
                        v-for="filterSegment in filterSegments"
                        :key="filterSegment._id"
                        :row="filterSegment"
                        :on-select-changed="() => segmentSelectChanged(filterSegment)"
                        :selectedSegments="selectedSegmentsList"
                    />
                    <div style="display: flex; justify-content: space-between; margin-top: 30px">
                        <a-button
                            class="add-segment-setting-btn"
                            @click="() => this.$router.push(`/chatbot/user-segments`)"
                            style="display: none"
                        >
                            <span class="material-icons mr-2" style="font-size: 20px"> settings </span>
                            <span>{{ $t("visitor.manageSegments") }}</span>
                        </a-button>
                        <a-button class="add-segment-confirm-btn" @click="segmentHandleCancel">
                            {{ $t("visitor.confirm") }}
                        </a-button>
                    </div>
                </template>
            </FormModal>

            <FormModal
                id="add-to-tag"
                :title="$t('visitor.addTag')"
                v-model="tagModalVisible"
                :footer="false"
                v-if="tagModalVisible"
                @cancel="tagModalVisible = false"
            >
                <template #body>
                    <div class="add-segment-search" style="display: flex; justify-content: center">
                        <input
                            :placeholder="$t('visitor.filterName')"
                            style="border: none; border-radius: 5px; padding: 2px; width: 200px"
                            v-model="tagSearch"
                            @input="tagSearchChange"
                        />
                        <span class="material-icons mx-2 add-segment-search-icon"> search </span>
                    </div>
                    <VisitorAddSegment
                        v-for="filterTag in getFilteredTags()"
                        :key="filterTag._id"
                        :row="filterTag"
                        :on-select-changed="() => tagSelectChanged(filterTag)"
                        :selectedSegments="selectedTagsList"
                    />
                    <div style="display: flex; justify-content: space-between; margin-top: 30px">
                        <a-button
                            class="manage-tags-btn"
                            @click="() => this.$router.push(`/tags`)"
                            style="display: none"
                        >
                            <span class="material-icons mr-2" style="font-size: 20px"> settings </span>
                            <span>{{ $t("visitor.manageTags") }}</span>
                        </a-button>
                        <a-button class="add-segment-confirm-btn" @click="tagHandleCancel">
                            {{ $t("visitor.confirm") }}
                        </a-button>
                    </div>
                </template>
            </FormModal>

            <!-- Custom Delete Modal -->
            <div class="custom-delete-modal-overlay" v-if="deleteUserVisible" @click.self="deleteUserVisible = false">
                <div class="custom-delete-modal">
                    <div class="custom-modal-header">
                        <div class="header-icon-wrapper">
                            <span class="material-icons header-icon">warning</span>
                        </div>
                        <h3 class="modal-title">{{ $t('visitor.deleteUser') }}</h3>
                        <button class="close-btn" @click="deleteUserVisible = false">
                            <span class="material-icons">close</span>
                        </button>
                    </div>
                    <div class="custom-modal-body">
                        <div class="warning-message">
                            <span class="material-icons message-icon">info</span>
                            <p>{{ $t("message.deleteVisitor") }}</p>
                        </div>
                    </div>
                    <div class="custom-modal-footer">
                        <button class="cancel-btn" @click="deleteUserVisible = false">
                            <span class="material-icons">close</span>
                            <span>{{ $t("common.cancel") }}</span>
                        </button>
                        <button class="delete-btn" @click="deleteUser()">
                            <span class="material-icons">delete</span>
                            <span>{{ $t("common.delete") }}</span>
                        </button>
                    </div>
                </div>
            </div>

            <CreateEventModal
                :calendarList="calendarList"
                v-if="newEventModalVisible"
                @close="newEventModalVisible = false"
                @editEvent="editEvent($event)"
            />
        </a-spin>
        <VisitorBanModal
            v-if="visitor"
            :visitor="visitor"
            :ban-modal-visible="banModalVisible"
            @close="banModalVisible = false"
            @changed="visitorBanUpdated"
        />
        <SendCapiEventModal
            v-if="showCapiEventModal"
            :visible="showCapiEventModal"
            :contact="visitor"
            @cancel="showCapiEventModal = false"
        />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import VisitorChatList from "../Visitors/VisitorChatList";
import VisitorMailList from "../Visitors/VisitorMailList";
import VisitorNotes from "../Visitors/VisitorNotes.vue";
import VisitorAttributes from "../Visitors/VisitorAttributes.vue";
import VisitorAddSegment from "../Visitors/VisitorAddSegment";
import VisitorActivities from "../Visitors/VisitorActivities";
import router from "../../../router";
import { PERMISSION_TYPES } from "../../../language/permissionTypes";
import * as _ from "lodash";
import PreferredAgents from "../../../components/PreferredAgents";
import PreferredDepartment from "../../../components/PreferredDepartment.vue";
import VisitorTaskListView from "../../../components/task/VisitorTaskListView.vue";
import Modal2 from "../../../components/common/Modal2.vue";
import webIcon from "./components/svg/WebIcon.vue";
import whatsappIcon from "../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import gmailIcon from "../Mail/icons/MailIcon.vue";
import CreateEventModal from "../Calendar/Component/CreateEventModal.vue";
import VisitorEventList from "./VisitorEventList.vue";
import { SUPPRESSION_API } from "../../../api/suppression";
import VisitorBanModal from "../../../components/VisitorBanModal.vue";
import FormModal from "../../../components/FormModal.vue";
import { transferFlowlu } from "../../../api/chat";
import ChatWatcher from "../../../ChatWatcherV2";
import VisitorMediaAndDocuments from "../../../components/popup-chat/chat-window/VisitorMediaAndDocuments.vue";
import ContactProfileAutomationButton from "../../../components/common/ContactProfileAutomationButton.vue";
import SupsisButton from "../Settings/components/SupsisButton.vue";
import ContactRelatedList from "./ContactRelatedList.vue";
import { sendSocketMessage } from "../../../utils/socketStream";
import { maskContactInfo, isMaskContactInfo } from "../../../utils/utils";
import AiVoiceAgentCallStarter from "../../../components/AiVoiceAgentCallStarter.vue";
import ContactAvatar from "../../../components/popup-chat/chat-window/ContactAvatar.vue";
import TicketStatusSwitcher from "../Ticket/components/TicketStatusSwitcher.vue";
import PlatformIconViewer from "../../../components/common/PlatformIconViewer.vue";
import MetaReferralList from "../../../components/popup-chat/chat-window/MetaReferralList.vue";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";
import VisitorCalls from "./VisitorCalls.vue";
import SendCapiEventModal from "../../../components/capi/SendCapiEventModal.vue";

const log = log2("VisitorDetailComponent");
export default {
    name: "VisitorDetailComponent",
    components: {
        VisitorChatList,
        VisitorMailList,
        VisitorAttributes,
        VisitorAddSegment,
        VisitorNotes,
        VisitorActivities,
        PreferredAgents,
        PreferredDepartment,
        VisitorTaskListView,
        Modal2,
        webIcon,
        whatsappIcon,
        gmailIcon,
        CreateEventModal,
        VisitorEventList,
        VisitorBanModal,
        FormModal,
        VisitorMediaAndDocuments,
        ContactProfileAutomationButton,
        SupsisButton,
        ContactRelatedList,
        AiVoiceAgentCallStarter,
        ContactAvatar,
        TicketStatusSwitcher,
        PlatformIconViewer,
        MetaReferralList,
        VisitorCalls,
        SendCapiEventModal,
    },
    props: {
        visitorId: {
            type: String,
            default: "",
        },
        visibleMail: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectedTaskIndex: 0,
            visitorTask: null,
            visitor: {},
            newEventModalVisible: false,
            segmentModalVisible: false,
            tagModalVisible: false,
            deleteUserVisible: false,
            segments: null,
            segmentSearch: "",
            tagSearch: "",
            filterSegments: null,
            filteredTags: [],
            hovered: false,
            selectSegments: [],
            selectTags: [],
            selectedSegmentsList: [],
            selectedTagsList: [],
            notes: [],
            activities: [],
            visitorBanned: false,
            tabKey: "",
            mapUsers: {},
            preferredAgentsModal: false,
            cloneVisitorId: this.visitorId,
            otherVisitors: [],
            selectedMergeVisitorId: "",
            loading: false,
            banModalVisible: false,
            newEvent: {},
            bannedList: [],
            showCapiEventModal: false,
        };
    },
    async mounted() {
        this.fetchVisitorTask();
        this.getTags("contact");
        this.selectedMergeVisitorId = this.visitorId || this.cloneVisitorId;
        this.tabKey = !!this.visibleMail ? "visitor-mails" : "visitor-details";
        if (this.visitorId) this.cloneVisitorId = this.visitorId;
        this.fetch();

        this.listSegments()
            .then((res) => {
                console.log("mounted segments", res);
                this.segments = res || [];
                this.filterSegments = res || [];
                const selectedSeg = res.filter((x) => {
                    const qwe = x.users.filter((user) => {
                        return user === this.visitor._id;
                    });
                    return qwe.length > 0;
                });
                this.selectedSegmentsList = selectedSeg || [];
                this.selectSegments = selectedSeg || [];
            })
            .finally(() => {});
        const notesData = await this.getNotes(this.visitorId);
        this.notes = notesData;
        console.log("notessssss", { notesData });
        if(this.visitorId) {
            this.activities = await this.getVisitorActivity(this.visitorId);
        }
        this.filteredTags = this.tags || [];
        this.selectedTagsList = this.visitor.tags || [];
        this.selectTags = this.visitor.tags || [];
        this.mapUsers = this.users.reduce((acc, user) => {
            acc[user._id] = user;
            return acc;
        }, {});
        this.bannedList = await SUPPRESSION_API.list();

        this.$nextTick(() => {
            this.checkScrollPosition();

            // Check for scroll position changes
            if (this.$refs.actionRight) {
                this.$refs.actionRight.addEventListener("scroll", this.checkScrollPosition);

                // Also check on window resize
                window.addEventListener("resize", this.checkScrollPosition);
            }
        });
    },
    computed: {
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapGetters({
            checkPermission: "auth/checkPermission",
            myActiveConversations: "chat/getMyActiveConversations",
            visitorDetailWebTabs: "webtabs/getVisitorDetailWebTabs",
            getWebTabUrl: "webtabs/getWebTabUrl",
        }),
        currentWebTab() {
            if (!this.tabKey.startsWith("webtab-")) return null;
            const webTabId = this.tabKey.replace("webtab-", "");
            return this.visitorDetailWebTabs.find((tab) => tab._id === webTabId);
        },
        currentWebTabUrl() {
            if (!this.currentWebTab) return null;
            return this.getWebTabUrl(this.currentWebTab, this.visitor);
        },

        ...mapState({
            tags: (state) => state.tag.tags.data,
            user: (state) => state.auth.user,
            users: (state) => state.user.users.data,
            site: (state) => state.site.site,
            isAdmin: (state) => state.auth.adminUser != null,
            conversations: (state) => state.chat.conversations,
            channels: (state) => state.channel.channels,
            calendarList: (state) => state.calendar.calendarList,
            usersMap: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
            windows: (state) => state.app.windows,
            maskSensitiveInfo: (state) => state.setting.settings.maskSensitiveInfo,
            isRoot: (state) => _.get(state, "auth.user.role.isRoot", false),
        }),
        visitorDetailPermission() {
            return [
                PERMISSION_TYPES["visitor.delete"].tr.name,
                PERMISSION_TYPES["visitor.update"].tr.name,
                PERMISSION_TYPES["visitor.block"].tr.name,
                PERMISSION_TYPES["visitor.unblock"].tr.name,
            ].some((permission) => this.checkPermission(permission));
        },
        ...mapGetters({
            contactRelatedListModules: "module/contactRelatedListModules",
        }),
    },
    methods: {
        isMaskContactInfo,
        isShouldMask(val) {
            return (
                !this.isRoot &&
                this.maskSensitiveInfo &&
                (val === this.visitor.email || val === this.visitor.whatsappNumber || val === this.visitor.phone)
            );
        },
        maskVisitorField(key, val, length = 5) {
            return this.isMaskContactInfo(key)
                ? maskContactInfo(val, length)
                : this.isShouldMask(val)
                ? maskContactInfo(val, length)
                : val;
        },
        ...mapActions({
            updateTags: "chat/updateTags",
            getVisitor: "visitor/getVisitor",
            updateTagVisitor: "visitor/updateTagVisitor",
            deleteTagVisitor: "visitor/deleteTagVisitor",
            getTags: "tag/getTags",
            deleteVisitor: "visitor/deleteVisitor",
            listSegments: "CB/listSegments",
            addUserToSegment: "CB/addUserToSegment",
            deleteSegment: "CB/deleteSegment",
            banVisitor: "visitor/banVisitor",
            unbanVisitor: "visitor/unbanVisitor",
            getNotes: "visitor/getVisitorNotes",
            getVisitorActivity: "visitor/getVisitorActivity",
            updatePreferredAgents: "visitor/updatePreferredAgents",
            getOtherProfiles: "visitor/getOtherProfiles",
            mergeVisitorsAction: "visitor/mergeVisitors",
            addNewWindow: "app/addNewWindow",
            updateVisitorAttr: "visitor/updateVisitorAttr",
            setWindows: "app/setWindows",
            getVisitorTasks: "tasks/getVisitorTasks",
            updateTask: "tasks/updateTask",
            updateTaskPosition: "tasks/updateTaskPosition",
        }),
        fetchVisitorTask() {
            this.visitorTask = [];

            this.getVisitorTasks({
                siteId: this.site._id,
                visitorId: this.cloneVisitorId,
            })
                .then((response) => {
                    if (Array.isArray(response?.items)) {
                        this.$set(this, "visitorTask", response.items);
                    } else if (Array.isArray(response)) {
                        this.$set(this, "visitorTask", response);
                    } else {
                        this.visitorTask = [];
                        console.warn("Unexpected response format for visitor tasks:", response);
                    }
                })
                .catch((error) => {
                    this.visitorTask = [];
                    console.error("Error fetching visitor tasks:", error);
                });
        },
        fetchRelatedModuleRecords(moduleName) {
            return MODULE_API.getContactRelatedListRecords(moduleName, this.visitor._id).then((result) => {
                return result.items;
            });
        },
        getOwnerVal() {
            return this.visitor.owner || "";
        },
        vipCustomerChange(val) {
            this.updateVisitorAttr({
                visitorId: this.visitor._id,
                payload: {
                    vipCustomer: val,
                },
            }).then(() => {
                this.visitor.vipCustomer = val;
            });
        },
        ownerChange(val) {
            val = val === "" ? null : val;
            this.visitor.owner = val;

            this.updateVisitorAttr({
                visitorId: this.visitor._id,
                payload: {
                    owner: val,
                },
            }).then(() => {
                const oldOwner = this.visitor.owner;
                const payload = {
                    siteId: this.$store.state.site.site._id,
                    visitorId: this.visitor._id,
                    newOwnerId: val,
                    oldOwnerId: oldOwner,
                    actorUserId: this.$store.state.auth.user?._id,
                };
                sendSocketMessage("user contact-owner-changed", payload);
            });
        },
        flowluTransfer() {
            transferFlowlu(null, this.cloneVisitorId).then(() => {
                this.$toasted.show(this.$t("message.chatExportedToFlowlu"), {
                    duration: 3000,
                    position: "top-center",
                });
            });
        },
        openNewEvent() {
            if (this.checkPermission(PERMISSION_TYPES["calendar.create"].tr.name)) {
                this.newEventModalVisible = true;
            } else {
                this.$message.error(this.$t("noPermission"));
            }
        },
        visitorBanUpdated(suppressionDetails) {
            this.visitor.suppression = suppressionDetails;
        },
        editEvent(event) {
            this.newEvent = event;
        },
        async getVisitorInfo(visitorId) {
            console.log("getVisitorInfo visitorId", visitorId);
            this.selectedMergeVisitorId = visitorId;
            await this.fetch(visitorId);
            const selectedSeg = this.segments.filter((x) => {
                const qwe = x.users.filter((user) => {
                    return user === this.visitor._id;
                });
                return qwe.length > 0;
            });
            this.selectedSegmentsList = selectedSeg || [];
            this.selectSegments = selectedSeg || [];
        },

        /* async mergeVisitors() {
            this.loading = true;
            console.log("mergeVisitors datas", {
                selectedMergeVisitorId: this.selectedMergeVisitorId,
                otherVisitors: this.otherVisitors,
            });
            const otherVisitors = this.otherVisitors.filter((x) => x._id !== this.selectedMergeVisitorId);
            await this.mergeVisitorsAction({
                selectedMergeVisitorId: this.selectedMergeVisitorId,
                otherVisitors: otherVisitors,
            }).then(async (res) => {
                console.log("mergeVisitors result", res);
                this.$message.success(this.$t("message.mergeSuccess"));
                this.otherVisitors = [];
                await this.fetch();
                const selectedSeg = this.segments.filter((x) => {
                    const qwe = x.users.filter((user) => {
                        return user === this.visitor._id;
                    });
                    return qwe.length > 0;
                });
                this.selectedSegmentsList = selectedSeg || [];
                this.selectSegments = selectedSeg || [];
                this.loading = false;
            });
        },*/
        closeModal() {
            this.$emit("detailClose");
        },
        changeTabKey(key) {
            this.tabKey = key;
        },
        isWABusiness() {
            const channelId = _.get(this.visitor, "channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "whatsapp-business-api" || _.get(channel, "type") === "whatsapp-business-api-supsis";
        },
        isWhatsappV1() {
            const channelId = _.get(this.visitor, "channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "whatsapp-v1" || _.get(channel, "type") === "whatsapp-qr";
        },
        isWhatsappV2() {
            const channelId = _.get(this.visitor, "channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "whatsapp-v2";
        },
        isWhatsappV3() {
            const channelId = _.get(this.visitor, "channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "whatsapp-unipile";
        },
        startWhatsappChat() {
            const channelId = _.get(this.visitor, "channel");
            const whatsappNumber = _.get(this.visitor, "whatsappNumber");
            if (!whatsappNumber) return;
            if (!channelId) return;
            ChatWatcher.startChatImmediately({
                whatsappNumber: whatsappNumber,
                channelId: channelId,
            });
        },
        segmentSearchChange(e) {
            this.filterSegments = this.segments.filter((segment) => {
                return segment.name.match(new RegExp(this.segmentSearch, "gmi"));
            });
        },
        getFilteredTags() {
            if ((this.tagSearch || "").trim().length > 0) {
                return this.tags.filter((tag) => {
                    return tag.name.match(new RegExp(this.tagSearch, "gmi"));
                });
            } else {
                return this.tags;
            }
        },
        tagSearchChange(e) {},
        segmentRemove(segmentId, index) {
            this.selectedSegmentsList.splice(index, 1);
            this.deleteSegment({ segmentId: segmentId, userId: this.visitor._id })
                .then((res) => {})
                .finally(() => {});
        },
        async tagRemove(tagId, index) {
            this.selectedTagsList.splice(index, 1);
        },
        segmentSelectChanged(row) {
            const findIndex = this.selectSegments.findIndex((x) => x._id === row._id);
            if (findIndex < 0) {
                this.selectSegments = [...this.selectSegments, row];
            } else {
                this.selectSegments.splice(findIndex, 1);
            }
        },
        ban() {
            this.banModalVisible = true;
        },
        isBannedAnyPlatform() {
            return Object.keys(this.visitor.suppression || {}).find((key) => {
                const suppression = this.visitor.suppression[key];
                return suppression?.inbound || suppression?.outbound;
            });
        },
        tagSelectChanged(row) {
            log("tagSelectChanged this.selectTags --", this.selectTags);
            const findIndex = this.selectTags.findIndex((x) => x._id === row._id);
            if (findIndex < 0) {
                this.selectTags = [...this.selectTags, row];
            } else {
                this.selectTags.splice(findIndex, 1);
            }
        },
        // düzenlenen liste en son kaydedilmek üzere selectedSegmentsList değişkenine atılır
        segmentHandleCancel() {
            this.selectedSegmentsList = this.selectSegments || [];
            this.segmentSearch = "";
            this.segmentModalVisible = false;
            this.filterSegments = this.segments || [];
        },
        tagHandleCancel() {
            this.selectedTagsList = this.selectTags || [];
            this.tagSearch = "";
            this.tagModalVisible = false;
            this.filteredTags = this.tags || [];
        },
        showMessage(level, message, key = Math.random(), duration = 4) {
            this.$message[level]({
                content: message,
                key,
                duration,
            });
        },
        async deleteUser() {
            const result = await this.deleteVisitor(this.visitor._id);
            if (result.data === true) {
                this.$router.push(`/visitors/`);
                this.showMessage("success", this.$t("visitor.deleteSuccess"));
            }
        },
        async fetch(visitorId) {
            this.loading = true;
            console.log("fetch visitorId", { visitorId, cloneVisitorId: this.cloneVisitorId });
            await this.getVisitor(visitorId || this.cloneVisitorId).then((response) => {
                const visitor = response.data;
                const isRoot = _.get(this.user, "role.isRoot", false);
                // Kanal ownership kontrolü
                let isChannelOwner = false;
                if (visitor.channel) {
                    const channel = this.channels.find((c) => c._id === visitor.channel);
                    if (channel && channel.visibility && channel.visibility.owners) {
                        isChannelOwner = channel.visibility.owners.some(
                            (ownerId) => ownerId.toString() === this.user._id.toString()
                        );
                    }
                }

                // Eğer kullanıcı root değilse, visitor'ın owner'ı başkasıysa VE kanal owner'ı da değilse uyarı göster
                if (!isRoot && visitor.owner && visitor.owner !== this.user._id && !isChannelOwner) {
                    this.$message.warning(this.$t("message.visitorOwnershipWarning"));
                    const windows = Object.keys(this.windows).reduce((acc, windowType) => {
                        if (windowType !== "show-visitor") {
                            acc[windowType] = this.windows[windowType];
                        }
                        return acc;
                    }, {});
                    this.setWindows(windows);
                    return;
                }
                console.log("fetch response", visitor);
                this.loading = false;
                this.visitor = visitor;
                this.selectedTagsList = this.visitor.tags || [];
                this.visitorBanned = this.visitor.isBlocked;
                this.selectTags = this.visitor.tags || [];
                console.log("fetch this.segments", this.segments);
            });
        },
        seeAll() {
            this.$router.push(`/archives/${this.visitor._id}?allTime=1`);
        },
        createTask() {
            this.addNewWindow({
                type: "chat-create-task",
                title: this.$t("task.createTaskVisitor"),
                payload: {
                    visitorId: this.visitor._id,
                },
                zIndex: 1049,
            });
        },
        handleAttributeUpdate(updatedAttribute) {
            // Güncellenen attribute hem lokal olarak hem de store'da güncelleniyor
            if (updatedAttribute.isProfileField) {
                // Profil alanı güncellemesi - contactProperties içinde güncelleme veya ekleme
                const { key, value } = updatedAttribute;

                // contactProperties içinde var olan özelliği bul
                const contactProp = this.visitor.contactProperties?.find((cp) => {
                    const propId = typeof cp.property === "object" ? cp.property._id : cp.property;
                    return propId === key;
                });

                if (contactProp) {
                    // Var olan özelliği güncelle - reactive
                    this.$set(contactProp, "value", value);
                } else if (this.visitor.contactProperties) {
                    // Yeni özellik ekle
                    this.visitor.contactProperties.push({
                        property: key,
                        value: value,
                    });
                }
            } else {
                // Genel bilgi güncellemesi (fullname, email vb.)
                const { key, value } = updatedAttribute;

                // Ziyaretçi nesnesini reactive bir şekilde güncelle
                this.$set(this.visitor, key, value);
            }
        },
        async fetchNotes() {
            const newVisitorNotes = await this.getNotes(this.cloneVisitorId);
            this.notes = newVisitorNotes;
        },
        async handleStageChange(stageId) {
            const currentTask = this.visitorTask[this.selectedTaskIndex];

            const newStage = currentTask.statusList.find((stage) => stage._id === stageId);

            if (newStage && currentTask.currentStatus !== newStage.title) {
                try {
                    await this.updateTaskPosition({
                        taskId: currentTask.taskId,
                        payload: {
                            workflowId: currentTask.workflowId._id,
                            pipelineStageId: stageId,
                            fromPipelineId: currentTask.statusList.find((s) => s.title === currentTask.currentStatus)
                                ?._id,
                        },
                    });

                    await this.fetchVisitorTask();

                    this.$message.success(this.$t("visitor.taskStatusUpdateSuccess"));
                } catch (error) {
                    console.error("Task stage update error:", error);
                    this.$message.error(this.$t("visitor.taskStatusUpdateError"));
                }
            }
        },
        scrollLeft() {
            if (this.$refs.actionRight) {
                this.$refs.actionRight.scrollBy({
                    left: -100,
                    behavior: "smooth",
                });
            }
        },
        scrollRight() {
            if (this.$refs.actionRight) {
                this.$refs.actionRight.scrollBy({
                    left: 100,
                    behavior: "smooth",
                });
            }
        },
        checkScrollPosition() {
            if (!this.$refs.actionRight) return;

            const container = this.$refs.actionRight;
            const scrollLeft = container.scrollLeft;
            const scrollWidth = container.scrollWidth;
            const clientWidth = container.clientWidth;

            // Show left arrow if not at the beginning
            this.showLeftArrow = scrollLeft > 0;

            // Show right arrow if not at the end
            this.showRightArrow = scrollLeft + clientWidth < scrollWidth - 5;
        },
        copyToClipboard(text) {
            const input = document.createElement("input");
            input.value = text;
            document.body.appendChild(input);
            input.select();
            document.execCommand("copy");
            document.body.removeChild(input);
            this.$message.success(this.$t("visitor.copyToClipboard"));
        },
        getChannelNameOrPlatform() {
            const channelId = _.get(this.visitor, "channel");

            if (channelId) {
                const channel = this.channels.find((c) => c._id === channelId);
                return channel ? channel.name : this.visitor.platform || this.$t("visitor.notAvailable");
            }

            return this.visitor.platform || this.$t("visitor.notAvailable");
        },
        startWebphoneCall() {
            const phoneNumber = this.visitor.phone || this.visitor.whatsappNumber;

            if (!phoneNumber) {
                this.$message.warning(this.$t("visitor.noPhoneNumber"));
                return;
            }

            // Webphone'a arama başlatma event'i gönder
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.WEBPHONE_CALL_START, {
                phoneNumber: phoneNumber,
                contactName: this.visitor.fullname || this.$t("visitor.unknownTag"),
                contactId: this.visitor._id
            });

            this.$message.success(this.$t("visitor.webphoneCalling", { phoneNumber: phoneNumber }));
        },
        isMetaPlatform() {
            return ["instagram", "instagram-v2", "messenger", "meta-leads"].includes(this.visitor.platform);
        },
        openCapiEventModal() {
            this.showCapiEventModal = true;
        },
    },
    beforeMount() {
        if (!this.visitorDetailPermission) {
            return router.push("/denied");
        }
    },
    watch: {
        selectedSegmentsList(newValue) {
            this.listSegments()
                .then((listSegments) => {
                    const selectedSeg = listSegments.filter((x) => {
                        const qwe = x.users.filter((user) => {
                            return user === this.visitor._id;
                        });
                        return qwe.length > 0;
                    });
                    newValue.map((x) => {
                        const index = selectedSeg.findIndex((y, index) => {
                            return y._id === x.id;
                        });
                        if (index < 0) {
                            const segmentId = typeof x === "object" ? x._id : x;
                            this.addUserToSegment({ segmentId, userId: this.visitor._id })
                                .then((res) => {})
                                .finally(() => {});
                        } else {
                            selectedSeg.splice(index, 1);
                        }
                    });
                    selectedSeg.map((x) => {
                        this.deleteSegment({ segmentId: x._id, userId: this.visitor._id })
                            .then((res) => {})
                            .finally(() => {});
                    });
                })
                .finally(() => {});
        },
        selectedTagsList(newValue) {
            const tagsId = newValue.map((x) => x._id);
            this.updateTagVisitor({ visitorId: this.visitor._id, tagIds: tagsId });
        },
        visitorId(newValue) {
            if(newValue) {
                this.getVisitorActivity(newValue).then((items) => {
                    this.activities = items;
                })
            }
        },
    },
    beforeDestroy() {
        // Remove event listeners
        if (this.$refs.actionRight) {
            this.$refs.actionRight.removeEventListener("scroll", this.checkScrollPosition);
            window.removeEventListener("resize", this.checkScrollPosition);
        }
    },
};
</script>

<style lang="scss">
#visitor-detail {
    background-color: #ffffff;
    height: 100%;
    width: 100%;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
        "Helvetica Neue", sans-serif;

    .profile-card {
        &.full-width {
            background-color: white;
            border-radius: 8px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
            overflow: hidden;
            height: 100%;
        }

        .visitor-card-header,
        .card-header {
            padding: 16px !important;
            background-color: #f9fafb !important;
            border-bottom: 1px solid #e5e7eb !important;
            display: flex !important;
            align-items: center !important;
            gap: 12px !important;

            .visitor-card-icon,
            .material-icons {
                width: 32px !important;
                height: 32px !important;
                min-width: 32px !important;
                border-radius: 6px !important;
                background-color: rgba(99, 102, 241, 0.1) !important;
                color: #6366f1 !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                font-size: 18px !important;
            }

            > .material-icons {
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
                width: 32px !important;
                height: 32px !important;
                min-width: 32px !important;
                border-radius: 6px !important;
                background-color: rgba(99, 102, 241, 0.1) !important;
                color: #6366f1 !important;
                font-size: 18px !important;
                padding: 0 !important;
                margin-right: 12px !important;
            }

            .visitor-card-title,
            .card-title {
                font-size: 16px !important;
                font-weight: 600 !important;
                color: #374151 !important;
                margin: 0 !important;
                line-height: 1.4 !important;
                flex: 1 !important;
            }

            .card-actions {
                margin-left: auto;

                .secondary-btn {
                    background-color: transparent !important;
                    border: 1px solid #6366f1 !important;
                    color: #6366f1 !important;
                    font-size: 12px !important;
                    padding: 6px 12px !important;
                    border-radius: 6px !important;
                    display: flex !important;
                    align-items: center !important;
                    cursor: pointer !important;
                    gap: 6px !important;

                    .material-icons {
                        background: none !important;
                        width: auto !important;
                        height: auto !important;
                        min-width: auto !important;
                        font-size: 16px !important;
                        color: #6366f1 !important;
                        margin-right: 4px !important;
                    }

                    &:hover {
                        background-color: rgba(99, 102, 241, 0.05) !important;
                    }
                }
            }
        }
    }

    .detail-head {
        position: relative;
        background-color: #fff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        margin-bottom: 12px;
        border-radius: 0 0 10px 10px;
        overflow: visible;

        .head-color {
            height: 90px;
            background: linear-gradient(135deg, #4f46e5, #8b5cf6);
            position: relative;
            overflow: hidden;

            &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E");
                opacity: 0.7;
                z-index: 0;
            }

            .head-info {
                position: relative;
                z-index: 1;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                margin-right: 18px;
                margin-top: 8px;
                gap: 5px;

                .info-item {
                    display: flex;
                    align-items: center;
                    background-color: rgba(0, 0, 0, 0.2);
                    border: 1px solid rgba(255, 255, 255, 0.3);
                    border-radius: 8px;
                    padding: 4px 10px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    max-width: 200px;
                    position: relative;
                    overflow: hidden;

                    &:hover {
                        background-color: rgba(0, 0, 0, 0.3);
                        transform: translateY(-2px);
                        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);

                        .copy-icon {
                            opacity: 1;
                            transform: translateX(0);
                        }
                    }

                    .material-icons {
                        font-size: 14px;
                        color: white;
                        margin-right: 5px;
                    }

                    .info-text {
                        color: white;
                        font-size: 12px;
                        font-weight: 500;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 150px;
                    }

                    .copy-icon {
                        position: absolute;
                        right: 5px;
                        top: 50%;
                        transform: translateY(-50%) translateX(10px);
                        font-size: 12px;
                        color: white;
                        opacity: 0;
                        transition: all 0.2s ease;
                    }
                }

                .info-separator {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .material-icons {
                        font-size: 6px;
                        color: white;
                        opacity: 0.5;
                    }
                }
            }
        }

        .header-wrapper {
            display: flex;
            padding: 0 16px 10px;
            position: relative;
            overflow: visible;

            .avatar-section {
                margin-top: -45px;
                margin-right: 18px;

                .user-segment-avatar {
                    width: 90px;
                    height: 90px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #4f46e5, #8b5cf6);
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 32px;
                    border: 4px solid white;
                    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
                    position: relative;
                    z-index: 1;
                    overflow: hidden;
                    transition: transform 0.3s ease;

                    &:hover {
                        transform: scale(1.05);
                    }

                    .banned-frame {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        background: rgba(0, 0, 0, 0.7);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        z-index: 2;
                        cursor: pointer;
                        backdrop-filter: blur(2px);
                        transition: all 0.2s ease;

                        &:hover {
                            background: rgba(0, 0, 0, 0.8);
                        }

                        .material-icons {
                            font-size: 28px;
                            color: #ff4d4f;
                            margin-bottom: 4px;
                            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                        }

                        .banned-text {
                            font-size: 11px;
                            text-transform: uppercase;
                            font-weight: 700;
                            letter-spacing: 0.5px;
                            color: white;
                        }
                    }

                    .md-highlight-text {
                        font-size: 36px;
                        font-weight: 700;
                        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
                    }
                }
            }

            .user-info-section {
                flex: 1;
                padding-top: 10px;
                overflow: visible;

                .user-name-row {
                    display: flex;
                    align-items: center;
                    margin-bottom: 6px;

                    .user-name {
                        font-size: 22px;
                        font-weight: 700;
                        margin: 0;
                        margin-right: 12px;
                        color: #1f2937;
                        letter-spacing: -0.5px;
                    }

                    .vip-switch-container {
                        .ant-switch {
                            &.ant-switch-checked {
                                background-color: #f59e0b;
                                box-shadow: 0 2px 4px rgba(245, 158, 11, 0.4);
                            }

                            .ant-switch-inner {
                                font-weight: 700;
                                font-size: 11px;
                                letter-spacing: 0.5px;
                            }
                        }
                    }
                }

                .user-email {
                    font-size: 14px;
                    color: #4b5563;
                    display: flex;
                    align-items: center;
                    margin-bottom: 8px;

                    .mail-check {
                        margin-left: 6px;
                        font-size: 14px;
                        color: #10b981;
                        background-color: rgba(16, 185, 129, 0.1);
                        padding: 1px;
                        border-radius: 50%;
                        display: inline-flex;
                    }

                    .mail-close {
                        margin-left: 6px;
                        color: #ef4444;
                        font-size: 12px;
                    }
                }

                .user-segments-tags-row {
                    margin-top: 8px;
                    margin-bottom: 2px;

                    .segment-chips {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 6px;

                        .segment-chip {
                            background-color: #e0e7ff;
                            border-radius: 16px;
                            padding: 2px 10px;
                            display: flex;
                            align-items: center;
                            font-size: 12px;
                            font-weight: 500;
                            color: #4f46e5;
                            transition: all 0.2s ease;
                            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
                            white-space: nowrap;

                            &:hover {
                                background-color: #c7d2fe;
                                transform: translateY(-1px);
                                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                            }

                            &.tag-chip {
                                background-color: #fff7ed;
                                border: 1px solid #ffedd5;
                                color: #c2410c;

                                &:hover {
                                    background-color: #ffedd5;
                                    border-color: #fed7aa;
                                }

                                .tag-icon {
                                    font-size: 13px;
                                    margin-right: 4px;
                                    color: #ea580c;
                                }
                            }
                        }

                        .more-chip {
                            background-color: transparent;
                            border: 1px dashed #cbd5e1;
                            cursor: pointer;
                            font-weight: 600;

                            &:hover {
                                border-color: #6366f1;
                                color: #6366f1;
                                background-color: rgba(99, 102, 241, 0.05);
                            }
                        }

                        .add-segment-btn {
                            border: 1px dashed #cbd5e1;
                            background-color: transparent;
                            display: flex;
                            align-items: center;
                            padding: 2px 10px;
                            cursor: pointer;
                            gap: 4px;
                            transition: all 0.2s ease;

                            .material-icons {
                                font-size: 14px;
                                color: #6b7280;
                            }

                            &:hover {
                                border-color: #6366f1;
                                color: #6366f1;
                                background-color: rgba(99, 102, 241, 0.05);
                                transform: translateY(-1px);

                                .material-icons {
                                    color: #6366f1;
                                }
                            }
                        }
                    }
                }

                .quick-action-buttons {
                    margin-top: 10px;
                    display: flex;
                    justify-content: space-between;
                    overflow: visible;

                    .action-icons {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 8px;
                        align-items: center;
                        overflow: visible;

                        > * {
                            height: 32px !important;
                            width: 32px !important;
                            min-width: 32px !important;
                            max-width: 32px !important;
                            min-height: 32px !important;
                            margin: 0 !important;
                            padding: 0 !important;
                            display: flex !important;
                            align-items: center !important;
                            justify-content: center !important;
                            overflow: hidden !important;
                        }

                        .icon-btn {
                            height: 32px;
                            width: 32px;
                            border-radius: 6px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: none;
                            background-color: #f3f4f6;
                            color: #4b5563;
                            cursor: pointer;
                            transition: all 0.2s ease;
                            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
                            position: relative;
                            overflow: hidden;

                            //&::before {
                            //    content: '';
                            //    position: absolute;
                            //    top: 0;
                            //    left: 0;
                            //    right: 0;
                            //    bottom: 0;
                            //    background: radial-gradient(circle, transparent 1%, rgba(0, 0, 0, 0.05) 1%) center/15000%;
                            //    opacity: 0;
                            //    transition: opacity 0.3s ease;
                            //}

                            &:active::before {
                                opacity: 1;
                                background-size: 100%;
                                transition: 0s;
                            }

                            &:hover {
                                background-color: #e5e7eb;
                                color: #111827;
                                transform: translateY(-2px);
                                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);
                            }

                            .material-icons {
                                font-size: 18px;
                            }
                        }

                        .conversation-actions-button.ai-call,
                        .automation-trigger-button,
                        .ant-btn,
                        .btn-icon {
                            height: 32px !important;
                            width: 32px !important;
                            min-width: 32px !important;
                            border-radius: 6px !important;
                            display: flex !important;
                            align-items: center !important;
                            justify-content: center !important;
                            border: none !important;
                            background-color: #f3f4f6 !important;
                            color: #4b5563 !important;
                            cursor: pointer !important;
                            transition: all 0.2s ease !important;
                            padding: 0 !important;
                            margin: 0 !important;
                            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
                            position: relative !important;
                            overflow: hidden !important;

                            //&::before {
                            //    content: '';
                            //    position: absolute;
                            //    top: 0;
                            //    left: 0;
                            //    right: 0;
                            //    bottom: 0;
                            //    background: radial-gradient(circle, transparent 1%, rgba(0, 0, 0, 0.05) 1%) center/15000%;
                            //    opacity: 0;
                            //    transition: opacity 0.3s ease;
                            //}

                            &:active::before {
                                opacity: 1;
                                background-size: 100%;
                                transition: 0s;
                            }

                            &:hover {
                                background-color: #e5e7eb !important;
                                color: #111827 !important;
                                transform: translateY(-2px) !important;
                                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08) !important;
                            }

                            .material-icons,
                            i,
                            .myIcon {
                                font-size: 18px !important;
                            }
                        }

                        .ai-voice-agent-call-starter {
                            height: 32px !important;
                            width: 32px !important;
                            display: flex !important;
                            align-items: center !important;
                            justify-content: center !important;
                            background: #f3f4f6;
                            border-radius: 6px;
                            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
                            transition: all 0.2s ease;

                            &:hover {
                                background-color: #e5e7eb;
                                transform: translateY(-2px);
                                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);
                            }
                        }

                        .automation-button-wrapper {
                            height: 32px !important;
                            width: 32px !important;
                            display: flex !important;
                            align-items: center !important;
                            justify-content: center !important;
                            border-radius: 6px !important;
                            transition: all 0.2s ease;
                            overflow: visible !important;
                            position: relative !important;
                            z-index: 1060 !important;

                            &:hover {
                                transform: translateY(-2px);
                            }
                        }

                        .automation-trigger-button span {
                            display: none !important;
                        }

                        .webphone-call-btn {
                            background-color: #34c759 !important;
                            color: white !important;

                            &:hover {
                                background-color: #2fb653 !important;
                                color: white !important;
                                transform: translateY(-2px);
                                box-shadow: 0 4px 8px rgba(52, 199, 89, 0.3);
                            }

                            .material-icons {
                                color: white !important;
                            }
                        }

                        .capi-event-btn {
                            background-color: #674ea7 !important;
                            color: white !important;

                            &:hover {
                                background-color: #563d9f !important;
                                color: white !important;
                                transform: translateY(-2px);
                                box-shadow: 0 4px 8px rgba(103, 78, 167, 0.3);
                            }

                            .material-icons {
                                color: white !important;
                            }
                        }

                        .more-menu {
                            .ant-dropdown-menu {
                                border-radius: 8px;
                                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                                border: 1px solid #e5e7eb;
                                overflow: hidden;

                                .ant-dropdown-menu-item {
                                    display: flex;
                                    align-items: center;
                                    padding: 8px 16px;
                                    transition: all 0.2s ease;

                                    &:hover {
                                        background-color: #f9fafb;
                                    }

                                    .material-icons {
                                        margin-right: 8px;
                                        font-size: 16px;
                                    }
                                }
                            }
                        }
                    }

                    .action-right {
                        margin-top: -65px;
                        max-width: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;
                        padding: 15px;
                        border-radius: 12px;
                        background: rgba(255, 255, 255, 0.9);
                        backdrop-filter: blur(10px);
                        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
                        transition: all 0.3s ease;
                        border: 1px solid rgba(99, 78, 236, 0.15);

                        &:hover {
                            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
                        }

                        .workflow-select-container {
                            display: flex;
                            flex-direction: column;
                            gap: 12px;
                            margin-bottom: 12px;
                            width: 100%;
                            overflow-x: auto;

                            &::-webkit-scrollbar {
                                height: 6px;
                            }

                            &::-webkit-scrollbar-thumb {
                                background-color: rgba(99, 78, 236, 0.3);
                                border-radius: 10px;
                            }

                            .workflow-name {
                                width: fit-content;
                                overflow: hidden;
                                position: relative;
                                margin-bottom: 4px;

                                span {
                                    display: block;
                                    font-size: 16px;
                                    color: #4b5563;
                                    font-weight: 600;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    cursor: pointer;
                                    transition: all 0.3s ease;
                                    position: relative;
                                }
                            }

                            .select {
                                display: flex;
                                align-items: center;
                                gap: 8px;
                                width: 100%;

                                .md-icon {
                                    color: #634eec !important;
                                    background-color: rgba(99, 78, 236, 0.1);
                                    padding: 5px;
                                    border-radius: 6px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    min-width: 30px;
                                }

                                .ant-select {
                                    flex: 1;
                                }

                                .ant-select-selection {
                                    border: 1px solid rgba(99, 78, 236, 0.3) !important;
                                    border-radius: 8px !important;
                                    transition: all 0.2s ease !important;
                                    height: 36px !important;
                                    background: white !important;

                                    &:hover,
                                    &:focus {
                                        border-color: #634eec !important;
                                        box-shadow: 0 0 0 2px rgba(99, 78, 236, 0.2) !important;
                                    }

                                    .ant-select-selection__rendered {
                                        line-height: 34px !important;
                                        margin-left: 12px !important;
                                    }
                                }
                            }
                        }

                        .ticket-status-switcher-container {
                            padding-bottom: 5px;
                            max-width: 400px;
                            overflow-x: scroll;

                            &::-webkit-scrollbar {
                                height: 6px;
                            }

                            &::-webkit-scrollbar-thumb {
                                background-color: rgba(99, 78, 236, 0.3);
                                border-radius: 10px;
                            }

                            .ticket-status-switcher {
                                border-radius: 20px;
                                overflow: hidden;
                                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                                width: fit-content;
                                min-width: 100%;
                                justify-content: flex-start;
                            }
                        }
                    }
                }
            }

            .header-controls {
                position: absolute;
                top: -45px;
                right: 16px;
                display: flex;
                gap: 10px;
                z-index: 10;

                .header-control-item {
                    background-color: rgba(255, 255, 255, 0.95);
                    padding: 8px 10px;
                    border-radius: 8px;
                    backdrop-filter: blur(10px);
                    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
                    border: 1px solid rgba(99, 102, 241, 0.2);
                    min-width: 140px;
                    transition: all 0.2s ease;
                    display: flex;
                    flex-direction: column;

                    &:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
                        border-color: rgba(99, 102, 241, 0.35);
                    }

                    .control-label {
                        display: flex;
                        align-items: center;
                        margin-bottom: 4px;
                        color: #4f46e5;
                        font-size: 11px;
                        font-weight: 500;
                        letter-spacing: 0.2px;
                        opacity: 0.9;

                        .material-icons {
                            font-size: 14px;
                            margin-right: 4px;
                            opacity: 0.9;
                        }
                    }

                    .control-content {
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        width: 100%;
                        min-height: 24px;

                        .ant-avatar,
                        .avatar-group-item {
                            width: 24px !important;
                            height: 24px !important;
                            min-width: 24px !important;
                            min-height: 24px !important;
                            font-size: 12px !important;
                            line-height: 24px !important;
                        }

                        .ant-avatar-string {
                            font-size: 11px !important;
                            line-height: 24px !important;
                        }

                        .avatar-name {
                            font-size: 11px !important;
                        }
                    }

                    &.ownership-section {
                        .owner-select {
                            width: 100%;

                            .ant-select-selection {
                                border-radius: 6px;
                                border: 1px solid #e2e8f0;
                                transition: all 0.2s ease;
                                background-color: rgba(255, 255, 255, 0.8);
                                min-height: 28px;
                                padding-left: 2px;

                                .ant-select-selection__rendered {
                                    line-height: 26px;
                                    font-size: 12px;
                                }

                                &:hover,
                                &:focus {
                                    border-color: #6366f1;
                                    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.1);
                                }
                            }
                        }
                    }

                    &.preferred-agents-section,
                    &.preferred-department-section {
                        .ant-select {
                            .ant-select-selection {
                                border-radius: 6px;
                                border: 1px solid #e2e8f0;
                                background-color: rgba(255, 255, 255, 0.8);
                                min-height: 28px;
                                padding-left: 2px;

                                .ant-select-selection__rendered {
                                    line-height: 26px;
                                    font-size: 12px;
                                }
                            }
                        }

                        .ant-tag {
                            margin: 2px;
                            border-radius: 4px;
                            background-color: #f1f5f9;
                            border-color: #e2e8f0;
                            color: #475569;
                            font-size: 11px;
                            height: 22px;
                            line-height: 20px;

                            .anticon-close {
                                font-size: 10px;
                                color: #94a3b8;

                                &:hover {
                                    color: #475569;
                                }
                            }
                        }

                        .agent-avatar-name {
                            font-size: 11px;
                        }
                    }
                }
            }
        }
    }

    .page-tabs {
        display: flex;
        background-color: #fff;
        border-bottom: 1px solid #e5e7eb;
        overflow-x: auto;
        scrollbar-width: thin;
        padding: 0 8px;
        position: sticky;
        top: 0;
        z-index: 5;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);

        &::-webkit-scrollbar {
            height: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0.15);
            border-radius: 10px;
        }

        .tab-item {
            padding: 0 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            font-weight: 500;
            color: #6b7280;
            cursor: pointer;
            white-space: nowrap;
            transition: all 0.2s ease;
            border-bottom: 2px solid transparent;
            height: 42px;
            position: relative;
            margin: 0 2px;

            .material-icons {
                font-size: 18px;
                margin-right: 6px;
                width: 18px;
                height: 18px;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s ease;
                opacity: 0.85;
            }

            &::after {
                content: "";
                position: absolute;
                bottom: -1px;
                left: 0;
                width: 100%;
                height: 2px;
                background-color: #6366f1;
                transform: scaleX(0);
                transition: transform 0.25s ease;
                border-radius: 2px 2px 0 0;
            }

            &:hover {
                color: #4b5563;
                background-color: rgba(243, 244, 246, 0.7);

                .material-icons {
                    opacity: 1;
                }
            }

            &.active {
                color: #6366f1;
                font-weight: 600;
                background-color: rgba(99, 102, 241, 0.06);

                &::after {
                    transform: scaleX(0.85);
                }

                .material-icons {
                    color: #6366f1;
                    opacity: 1;
                }
            }
        }
    }

    .tab-content {
        height: calc(100% - 290px);
        overflow: auto;
        background-color: #f9fafb;

        .content-container {
            height: 100%;

            .attributes-row {
                display: flex;
                gap: 16px;
                width: 100%;
                margin-top: 16px;

                .flex-1 {
                    flex: 1;
                    min-width: 0;
                }
            }

            .profile-cards-grid {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 16px;
                height: 100%;

                .profile-card {
                    background-color: white;
                    border-radius: 8px;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    overflow: hidden;
                    height: 100%;

                    &.full-width {
                        grid-column: 1 / -1;
                    }

                    &.attributes-card {
                        grid-column: span 2;
                    }

                    .visitor-card-header {
                        padding: 16px;
                        background-color: #f9fafb;
                        border-bottom: 1px solid #e5e7eb;
                        display: flex;
                        align-items: center;
                        gap: 12px;

                        .visitor-card-icon {
                            width: 32px;
                            height: 32px;
                            min-width: 32px;
                            border-radius: 6px;
                            background-color: rgba(99, 102, 241, 0.1);
                            color: #6366f1;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .material-icons {
                                font-size: 18px;
                            }
                        }

                        .visitor-card-title {
                            font-size: 16px;
                            font-weight: 600;
                            color: #374151;
                            margin: 0;
                            line-height: 1.4;
                            flex: 1;
                        }

                        .card-actions {
                            margin-left: auto;

                            .secondary-btn {
                                background-color: transparent;
                                border: 1px solid #6366f1;
                                color: #6366f1;
                                font-size: 12px;
                                padding: 6px 12px;
                                border-radius: 6px;
                                display: flex;
                                align-items: center;
                                cursor: pointer;
                                gap: 6px;

                                .material-icons {
                                    font-size: 16px;
                                }

                                &:hover {
                                    background-color: rgba(99, 102, 241, 0.05);
                                }
                            }
                        }
                    }

                    .card-body {
                        padding: 0px;
                        height: calc(100% - 65px);
                        overflow: hidden;

                        .visitor-attributes {
                            height: 100%;
                            border: none;
                            box-shadow: none;
                            padding: 0;
                        }

                        &.p-0 {
                            padding: 0;
                        }

                        .modern-select {
                            width: 100%;

                            .ant-select-selection {
                                border-radius: 6px;

                                &:hover,
                                &:focus {
                                    border-color: #6366f1;
                                }
                            }
                        }

                        .tags-container,
                        .segments-container {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 8px;

                            .tag-item,
                            .segment-item {
                                background-color: #e0e7ff;
                                border-radius: 4px;
                                padding: 3px 8px;
                                display: flex;
                                align-items: center;
                                font-size: 12px;
                                color: #4f46e5;

                                .tag-text,
                                .segment-text {
                                    margin-right: 5px;
                                }

                                .tag-close,
                                .segment-close {
                                    font-size: 14px;
                                    cursor: pointer;
                                    opacity: 0.7;

                                    &:hover {
                                        opacity: 1;
                                    }
                                }
                            }

                            .add-btn {
                                background-color: transparent;
                                border: 1px dashed #cbd5e1;
                                border-radius: 4px;
                                padding: 3px 8px;
                                display: flex;
                                align-items: center;
                                font-size: 12px;
                                color: #6b7280;
                                cursor: pointer;

                                .material-icons {
                                    font-size: 14px;
                                    margin-right: 4px;
                                }

                                &:hover {
                                    border-color: #6366f1;
                                    color: #6366f1;
                                }
                            }
                        }
                    }
                }
            }

            .profile-card.full-width {
                background-color: white;
                border-radius: 8px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                overflow: hidden;
                height: 100%;
            }

            // Meta Lead Form
            .meta-lead-info {
                padding: 20px !important;

                .meta-lead-grid {
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                }

                .meta-lead-section {
                    .meta-lead-section-title {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        font-size: 15px;
                        font-weight: 600;
                        color: #1f2937;
                        margin-bottom: 12px;
                        padding-bottom: 8px;
                        border-bottom: 1px solid #e5e7eb;

                        .material-icons {
                            font-size: 20px !important;
                            width: auto !important;
                            height: auto !important;
                            color: #6b7280;
                        }
                    }
                }

                .meta-lead-fields {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
                    gap: 12px;
                }

                .meta-lead-field {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                    padding: 10px 12px;
                    background: #f9fafb;
                    border-radius: 6px;
                    border: 1px solid #f3f4f6;

                    .field-label {
                        font-size: 12px;
                        font-weight: 500;
                        color: #6b7280;
                        text-transform: uppercase;
                        letter-spacing: 0.025em;
                    }

                    .field-value {
                        font-size: 14px;
                        color: #111827;
                        word-break: break-all;
                    }

                    .field-mono {
                        font-family: "SF Mono", "Fira Code", "Fira Mono", "Roboto Mono", monospace;
                        font-size: 12px;
                        color: #4b5563;
                    }

                    .meta-lead-badge {
                        display: inline-block;
                        width: fit-content;
                        padding: 2px 8px;
                        border-radius: 4px;
                        font-size: 12px;
                        font-weight: 500;
                        background: #e0e7ff;
                        color: #3730a3;

                        &.status-new_lead {
                            background: #d1fae5;
                            color: #065f46;
                        }

                        &.status-open {
                            background: #dbeafe;
                            color: #1e40af;
                        }

                        &.status-connected {
                            background: #fef3c7;
                            color: #92400e;
                        }
                    }
                }
            }

            // WebTab İçerikleri
            &.webtab-content {
                .webtab-card {
                    display: flex;
                    flex-direction: column;

                    .webtab-iframe-container {
                        flex: 1;
                        padding: 0 !important;
                        position: relative;
                        min-height: 500px;

                        .webtab-iframe {
                            width: 100%;
                            height: 100%;
                            border: none;
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                        }

                        .webtab-error {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            height: 100%;
                            color: #ff4d4f;
                            gap: 12px;

                            .material-icons {
                                font-size: 48px;
                            }
                        }
                    }
                }
            }
        }
    }
    .add-attribute-button {
        position: absolute;
        bottom: 16px;
        right: 16px;
        width: 40px;
        height: 40px;
        border-radius: 50%; // Make it circular
        background: #6366f1;
        color: white;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); // Slightly stronger shadow
        z-index: 10;
        transition: all 0.2s ease-in-out;

        &:hover {
            background: #4f46e5;
            transform: scale(1.05) translateY(-2px); // Add subtle lift
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
        }

        .material-icons {
            font-size: 22px; // Slightly larger icon
        }
    }
}

// Modal styling
#add-to-segment,
#add-to-tag {
    .add-segment-search {
        display: flex;
        align-items: center;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        padding: 8px 12px;
        margin-bottom: 15px;

        input {
            flex: 1;
            border: none;
            outline: none;
            font-size: 14px;

            &::placeholder {
                color: #9ca3af;
            }
        }

        .add-segment-search-icon {
            color: #9ca3af;
        }
    }

    .add-segment-setting-btn,
    .manage-tags-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f3f4f6;
        color: #4b5563;
        border: none;
        border-radius: 6px;
        padding: 6px 12px;
        font-size: 14px;

        .material-icons {
            font-size: 16px;
            margin-right: 6px;
        }

        &:hover {
            background-color: #e5e7eb;
        }
    }

    .add-segment-confirm-btn {
        background-color: #6366f1;
        color: white;
        border: none;
        border-radius: 6px;
        padding: 6px 12px;
        font-size: 14px;

        &:hover {
            background-color: #4f46e5;
        }
    }
}

    // Custom Delete Modal Styles - Sadece bu component için
    .custom-delete-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1055;
        animation: fadeInModal 0.2s ease;

        @keyframes fadeInModal {
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }

        .custom-delete-modal {
            background: white;
            border-radius: 16px;
            width: 90%;
            max-width: 500px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
            overflow: hidden;
            animation: slideUpModal 0.3s ease;

            @keyframes slideUpModal {
                from {
                    transform: translateY(20px);
                    opacity: 0;
                }
                to {
                    transform: translateY(0);
                    opacity: 1;
                }
            }

            .custom-modal-header {
                padding: 24px 24px 20px;
                border-bottom: 1px solid #f3f4f6;
                display: flex;
                align-items: center;
                gap: 16px;
                background: linear-gradient(135deg, #fff5f5 0%, #ffffff 100%);

                .header-icon-wrapper {
                    width: 48px;
                    height: 48px;
                    border-radius: 12px;
                    background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;

                    .header-icon {
                        font-size: 28px;
                        color: #dc2626;
                    }
                }

                .modal-title {
                    flex: 1;
                    margin: 0;
                    font-size: 20px;
                    font-weight: 700;
                    color: #1f2937;
                    letter-spacing: -0.5px;
                }

                .close-btn {
                    width: 32px;
                    height: 32px;
                    border-radius: 8px;
                    border: none;
                    background-color: #f3f4f6;
                    color: #6b7280;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.2s ease;
                    flex-shrink: 0;

                    &:hover {
                        background-color: #e5e7eb;
                        color: #374151;
                        transform: scale(1.05);
                    }

                    .material-icons {
                        font-size: 20px;
                    }
                }
            }

            .custom-modal-body {
                padding: 24px;

                .warning-message {
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;
                    padding: 16px;
                    background-color: #fef3c7;
                    border-left: 4px solid #f59e0b;
                    border-radius: 8px;

                    .message-icon {
                        font-size: 24px;
                        color: #d97706;
                        flex-shrink: 0;
                    }

                    p {
                        margin: 0;
                        font-size: 14px;
                        line-height: 1.6;
                        color: #78350f;
                        flex: 1;
                    }
                }
            }

            .custom-modal-footer {
                padding: 16px 24px 24px;
                display: flex;
                justify-content: flex-end;
                gap: 12px;

                button {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    padding: 12px 28px;
                    min-width: 140px;
                    height: 44px;
                    border: none;
                    border-radius: 10px;
                    font-size: 15px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                    position: relative;
                    overflow: hidden;
                    letter-spacing: 0.3px;

                    .material-icons {
                        font-size: 19px;
                        transition: transform 0.3s ease;
                    }

                    span:not(.material-icons) {
                        position: relative;
                        z-index: 1;
                    }

                    &:active {
                        transform: scale(0.97);
                    }

                    &::before {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        width: 0;
                        height: 0;
                        border-radius: 50%;
                        background: rgba(255, 255, 255, 0.3);
                        transform: translate(-50%, -50%);
                        transition: width 0.6s, height 0.6s;
                    }

                    &:hover::before {
                        width: 300px;
                        height: 300px;
                    }
                }

                .cancel-btn {
                    background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
                    color: #4b5563;
                    border: 1px solid #e5e7eb;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

                    &:hover {
                        background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
                        color: #1f2937;
                        transform: translateY(-2px);
                        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                        border-color: #d1d5db;

                        .material-icons {
                            transform: rotate(90deg);
                        }
                    }
                }

                .delete-btn {
                    background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
                    color: white;
                    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
                    position: relative;
                    height: 41px !important;

                    &:hover {
                        background: linear-gradient(135deg, #b91c1c 0%, #991b1b 100%);
                        transform: translateY(-2px);
                        box-shadow: 0 6px 20px rgba(220, 38, 38, 0.5);

                        .material-icons {
                            transform: scale(1.15) rotate(5deg);
                        }
                    }

                    &:focus {
                        outline: none;
                        box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2), 0 6px 20px rgba(220, 38, 38, 0.4);
                    }
                }
            }
        }
    }

// Dark mode support
.dark-mode {
    #visitor-detail {
        // Custom Delete Modal Dark Mode
        .custom-delete-modal-overlay {
            background-color: rgba(0, 0, 0, 0.7);

            .custom-delete-modal {
                background: #1f2937;
                box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);

                .custom-modal-header {
                    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
                    border-bottom-color: #374151;

                    .header-icon-wrapper {
                        background: linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%);

                        .header-icon {
                            color: #fca5a5;
                        }
                    }

                    .modal-title {
                        color: #f9fafb;
                    }

                    .close-btn {
                        background-color: #374151;
                        color: #9ca3af;

                        &:hover {
                            background-color: #4b5563;
                            color: #e5e7eb;
                        }
                    }
                }

                .custom-modal-body {
                    .warning-message {
                        background-color: #78350f;
                        border-left-color: #f59e0b;

                        .message-icon {
                            color: #fbbf24;
                        }

                        p {
                            color: #fef3c7;
                        }
                    }
                }

                .custom-modal-footer {
                    .cancel-btn {
                        background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
                        border-color: #4b5563;
                        color: #d1d5db;

                        &:hover {
                            background: linear-gradient(135deg, #4b5563 0%, #6b7280 100%);
                            color: #f9fafb;
                            border-color: #6b7280;
                        }
                    }

                    .delete-btn {
                        background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%);
                        box-shadow: 0 4px 12px rgba(220, 38, 38, 0.4);

                        &:hover {
                            background: linear-gradient(135deg, #b91c1c 0%, #7f1d1d 100%);
                            box-shadow: 0 6px 20px rgba(220, 38, 38, 0.5);
                        }
                    }
                }
            }
        }

        background-color: #111827;

        .detail-head {
            background-color: #1f2937;

            .head-color {
                background: linear-gradient(135deg, #4f46e5, #8b5cf6);
            }

            .header-wrapper {
                .user-info-section {
                    .user-name-row {
                        .user-name {
                            color: #f9fafb;
                        }
                    }

                    .user-email {
                        color: #9ca3af;
                    }

                    .user-segments-tags-row {
                        .segment-chips {
                            .segment-chip {
                                background-color: rgba(79, 70, 229, 0.2);
                                color: #a5b4fc;
                            }

                            .more-chip {
                                border-color: #4b5563;
                                color: #9ca3af;

                                &:hover {
                                    border-color: #818cf8;
                                    color: #818cf8;
                                }
                            }

                            .add-segment-btn {
                                border-color: #4b5563;
                                color: #9ca3af;

                                .material-icons {
                                    color: #9ca3af;
                                }

                                &:hover {
                                    border-color: #818cf8;
                                    color: #818cf8;

                                    .material-icons {
                                        color: #818cf8;
                                    }
                                }
                            }
                        }
                    }

                    .quick-action-buttons {
                        .action-icons {
                            .icon-btn {
                                background-color: #374151;
                                color: #d1d5db;

                                &:hover {
                                    background-color: #4b5563;
                                    color: #f9fafb;
                                }
                            }

                            .ai-voice-agent-call-starter,
                            .automation-button-wrapper,
                            .conversation-actions-button.ai-call,
                                                            .automation-trigger-button,
                                .ant-btn,
                                .btn-icon {
                                    background-color: #374151 !important;
                                    color: #d1d5db !important;

                                    &:hover {
                                        background-color: #4b5563 !important;
                                        color: #f9fafb !important;
                                    }
                                }

                                .webphone-call-btn {
                                    background-color: #10b981 !important;
                                    color: white !important;

                                    &:hover {
                                        background-color: #059669 !important;
                                        color: white !important;
                                        box-shadow: 0 4px 8px rgba(16, 185, 129, 0.3);
                                    }
                                }
                        }
                    }
                }
            }
        }

        .page-tabs {
            background-color: #1f2937;
            border-bottom-color: #374151;

            .tab-item {
                color: #9ca3af;

                &:hover {
                    color: #d1d5db;
                    background-color: rgba(129, 140, 248, 0.1);
                }

                &.active {
                    color: #818cf8;
                    border-bottom-color: #818cf8;
                    background-color: rgba(129, 140, 248, 0.15);

                    &::after {
                        background-color: #818cf8;
                    }

                    .material-icons {
                        color: #818cf8;
                    }
                }
            }
        }

        .tab-content {
            background-color: #111827;

            .content-container {
                .profile-cards-grid {
                    .profile-card {
                        background-color: #1f2937;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);

                        .visitor-card-header,
                        .card-header {
                            background-color: #111827 !important;
                            border-bottom-color: #374151 !important;

                            .visitor-card-icon,
                            .material-icons {
                                background-color: rgba(129, 140, 248, 0.15) !important;
                                color: #818cf8 !important;
                            }

                            > .material-icons {
                                background-color: rgba(129, 140, 248, 0.15) !important;
                                color: #818cf8 !important;
                            }

                            .visitor-card-title,
                            .card-title {
                                color: #e5e7eb !important;
                            }

                            .card-actions {
                                .secondary-btn {
                                    border-color: #818cf8 !important;
                                    color: #818cf8 !important;

                                    .material-icons {
                                        color: #818cf8 !important;
                                    }

                                    &:hover {
                                        background-color: rgba(129, 140, 248, 0.1) !important;
                                    }
                                }
                            }
                        }

                        .card-body {
                            .modern-select {
                                .ant-select-selection {
                                    background-color: #374151;
                                    border-color: #4b5563;
                                    color: #e5e7eb;

                                    &:hover,
                                    &:focus {
                                        border-color: #818cf8;
                                    }
                                }
                            }

                            .tags-container,
                            .segments-container {
                                .tag-item,
                                .segment-item {
                                    background-color: rgba(79, 70, 229, 0.2);
                                    color: #a5b4fc;
                                }

                                .add-btn {
                                    border-color: #4b5563;
                                    color: #9ca3af;

                                    &:hover {
                                        border-color: #818cf8;
                                        color: #818cf8;
                                    }
                                }
                            }
                        }
                    }
                }

                .profile-card.full-width {
                    background-color: #1f2937;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
                }
            }
        }
    }
}

@media (max-width: 768px) {
    #visitor-detail {
        .header-wrapper {
            flex-direction: column;
            align-items: center;
            padding-bottom: 20px;

            .avatar-section {
                margin-right: 0;
                margin-bottom: 15px;
                display: flex;
                justify-content: center;
            }

            .user-info-section {
                text-align: center;

                .user-name-row {
                    justify-content: center;
                }

                .user-email {
                    justify-content: center;
                }

                .user-segments-tags-row {
                    .segment-chips {
                        justify-content: center;
                    }
                }

                .quick-action-buttons {
                    .action-icons {
                        justify-content: center;

                        > * {
                            height: 40px !important;
                            width: 40px !important;
                            min-width: 40px !important;
                            max-width: 40px !important;
                            min-height: 40px !important;
                        }

                        .icon-btn {
                            height: 40px;
                            width: 40px;

                            .material-icons {
                                font-size: 22px;
                            }
                        }

                        .ai-voice-agent-call-starter,
                        .automation-button-wrapper,
                        .conversation-actions-button.ai-call,
                        .automation-trigger-button,
                        .ant-btn,
                        .btn-icon {
                            height: 40px !important;
                            width: 40px !important;
                            min-width: 40px !important;

                            i,
                            .material-icons,
                            .myIcon {
                                font-size: 22px !important;
                            }
                        }
                    }
                }
            }

            .header-controls {
                position: relative;
                top: 0;
                right: 0;
                flex-direction: column;
                width: 100%;
                margin-top: 15px;
                gap: 10px;

                .header-control-item {
                    width: 100%;
                    background-color: #ffffff;
                    box-shadow: none;
                    border: 1px solid #e5e7eb;
                }
            }
        }

        .page-tabs {
            .tab-item {
                flex: 1;
                padding: 10px 8px;
                height: 54px;
                justify-content: center;
                flex-direction: column;

                .material-icons {
                    margin-right: 0;
                    margin-bottom: 4px;
                    font-size: 22px;
                    width: 22px;
                    height: 22px;
                }
            }
        }

        .tab-content {
            padding: 12px;
            height: auto;

            .content-container {
                .profile-cards-grid {
                    grid-template-columns: 1fr;
                    height: auto;

                    .profile-card.attributes-card {
                        grid-column: span 1;
                    }
                }

                .attributes-row {
                    flex-direction: column;
                }

                .profile-card {
                    .visitor-card-header,
                    .card-header {
                        padding: 12px !important;

                        .visitor-card-icon,
                        .material-icons {
                            width: 36px !important;
                            height: 36px !important;
                            min-width: 36px !important;
                            font-size: 20px !important;
                        }

                        > .material-icons {
                            width: 36px !important;
                            height: 36px !important;
                            min-width: 36px !important;
                            font-size: 20px !important;
                        }

                        .visitor-card-title,
                        .card-title {
                            font-size: 15px !important;
                        }

                        .card-actions {
                            .secondary-btn {
                                padding: 4px 8px !important;
                                font-size: 11px !important;

                                .material-icons {
                                    font-size: 14px !important;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.disable {
    opacity: 0.3;
}
</style>
